module.exports = __webpack_public_path__ + "static/media/6-Diamond.5a8c7075.svg";